import { render, staticRenderFns } from "./reportPrime.vue?vue&type=template&id=7f698444&scoped=true"
import script from "@/scripts/reportPrime/reportPrime.js?vue&type=script&lang=js&external"
export * from "@/scripts/reportPrime/reportPrime.js?vue&type=script&lang=js&external"
import style0 from "./reportPrime.vue?vue&type=style&index=0&id=7f698444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f698444",
  null
  
)

export default component.exports